export function removeQueryParams(url: string | undefined | null) {
  if (url) {
    return url.replace(/\?[^#]+/, '');
  } else {
    return null;
  }
}

// List of allowed protocols should match ones from DSMAPI.
// See: https://github.com/socrata/dsmapi/blob/main/lib/dsmapi/util/urls.ex#L4
// List all protocols from DSMAPI in the following array,
// except `mailto`, which does not require two trailing slashes.
const validURLProtocols = ['http', 'https', 'news', 'ftp', 'ftps'];
const validURLPattern = new RegExp(`^(((${validURLProtocols.join('|')})://)|(mailto:))`, 'i');

/**
 * @description Checks if the provided URL should be rendered as an active link, meaning it has an allowed protocol.
 * @param url - The URL to check.
 * @returns {boolean} - Returns true if the URL should be rendered as a link, false otherwise
 */
export function shouldRenderLink(url: string | undefined | null): boolean {
  return !!url && validURLPattern.test(url);
}
